<template>
  <div class="bg-gradient-to-br from-white to-teal-50 rounded-xl shadow p-2 sm:p-4">
    <!-- Buscar Cliente -->
    <div v-if="mode == 'find'" class="mb-6">
      <div class="bg-white rounded-xl shadow p-4 sm:p-6 border border-teal-100">
        <div class="flex items-center gap-2 mb-4">
          <i class="fa fa-search text-teal-500 text-xl" />
          <span class="font-semibold text-teal-700">Buscar cliente</span>
        </div>
        <text-input 
          v-model="search" 
          label="Nombre, Alias o Cédula" 
          placeholder="Busca cliente por cédula, alias o nombre" 
          class="pb-3 w-full"
          input-class="focus:ring-teal-500 focus:border-teal-500"
        />
        <div class="space-y-2 mt-4 max-h-60 overflow-y-auto pr-2">
          <template v-if="clients.length">
            <button 
              v-for="client in clients" 
              :key="client.id" 
              class="flex flex-col sm:flex-row items-center gap-3 p-3 bg-teal-50 border border-teal-100 rounded-lg w-full hover:bg-teal-100 transition text-left shadow-sm"
              @click="addClient(client)"
            >
              <i class="fa fa-user text-teal-400 text-2xl" />
              <div>
                <div class="font-semibold text-teal-700">{{ client.name }}</div>
                <div class="text-xs text-gray-500">{{ client.identification }}</div>
              </div>
            </button>
          </template>
          <div v-else class="text-gray-400 text-center py-6">
            <i class="fa fa-user-times text-2xl mb-2" /><br />
            No se encontraron clientes con esos datos.
          </div>
        </div>
        <div class="mt-6 text-center">
          <button class="text-teal-700 font-semibold hover:underline" @click="mode = 'create'">
            <i class="fa fa-plus-circle mr-1" />Crear nuevo cliente
          </button>
        </div>
      </div>
    </div>

    <!-- Mostrar Cliente Seleccionado -->
    <div v-if="mode == 'show'" class="flex flex-col sm:flex-row items-center gap-4 bg-teal-50 border border-teal-200 rounded-xl p-4 sm:p-6 shadow mb-6">
      <i class="fa fa-user-circle text-4xl text-teal-500" />
      <div class="flex-1">
        <div class="font-bold text-teal-800 text-lg">{{ client.name }}</div>
        <div class="text-gray-600 text-sm">
          <span v-if="client.identification">{{ client.identification }} &bull; </span>
          <span v-if="client.email">{{ client.email }}</span>
        </div>
      </div>
      <button type="button" class="text-teal-700 font-semibold hover:underline" @click="mode = 'find'">
        <i class="fa fa-pen mr-1" />Editar
      </button>
    </div>

    <!-- Crear Cliente -->
    <div v-if="mode == 'create'">
      <form class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 bg-white border border-teal-100 rounded-xl p-4 md:p-8 shadow" @submit.prevent="saveClient">
        <text-input v-model="form.client.name" label="Nombre y Apellido de Cliente" class="mb-2" input-class="focus:ring-teal-500 focus:border-teal-500" />
        <text-input v-model="form.client.identification" label="Alias o Cédula de Cliente" class="mb-2" input-class="focus:ring-teal-500 focus:border-teal-500" />
        <text-input v-model="form.client.phone" label="Teléfono de Cliente" class="mb-2" input-class="focus:ring-teal-500 focus:border-teal-500" />
        <text-input v-model="form.client.address" label="Dirección de Cliente" class="mb-2" input-class="focus:ring-teal-500 focus:border-teal-500" />
        <text-input v-model="form.client.balance" disabled="true" label="Monto adeudado" class="mb-2" input-class="bg-gray-100 text-gray-500" />
        <div class="md:col-span-2 flex flex-col sm:flex-row gap-2 md:gap-4 mt-4">
          <button type="submit" class="btn-blue w-full sm:flex-1 shadow-md py-3">
            <i class="fa fa-save mr-2" />Guardar
          </button>
          <button type="button" class="w-full sm:flex-1 border border-teal-300 rounded-lg px-4 py-3 text-teal-700 font-semibold bg-teal-50 hover:bg-teal-100 transition" @click="mode = 'find'">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from './TextInput.vue'
import axios from 'axios'

export default {
  components: { TextInput },
  data: () =>{
    return {
      mode: 'find',
      form: {
        client: {},
        search: '',
      },
      clients: [],
      client: null,
      search: '',
    }
  },
  watch: {
    'search': function (val) {
      this.getClients()
    },
  },
  mounted() {
    this.getClients()
  },
  methods: {
    addClient(client)
    {
      this.client = client
      this.$emit('addClient', client)
      this.mode = 'show'
    },
    getClients()
    {
      if(this.search)
      {
        axios.get(`/getClients?search=${this.search}`).then(response => this.clients = response.data.data)    
      }else {
        axios.get('/getClients').then(response => this.clients = response.data.data)
      }
        
    },
    saveClient()
    {
      axios.post('/saveClient', this.form.client)
        .then(response => {
          this.client = response.data.data
          this.mode = 'show'
          this.$emit('addClient', response.data.data)
        })
        .catch(err => console.log(err))
    },
  },
}
</script>
